import { render, staticRenderFns } from "./InputSelectAutomation.vue?vue&type=template&id=61841018&scoped=true"
import script from "./InputSelectAutomation.vue?vue&type=script&lang=js"
export * from "./InputSelectAutomation.vue?vue&type=script&lang=js"
import style0 from "./InputSelectAutomation.vue?vue&type=style&index=0&id=61841018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61841018",
  null
  
)

export default component.exports